import * as React from 'react';
import { FunctionComponent, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Radio,
  FormControlLabel,
  RadioGroup,
} from '@material-ui/core';
import { useTranslate, useListContext } from 'react-admin';

type ExportChoice = 'filtered' | 'all';

type ModalExportProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (choice: ExportChoice) => void;
  resourceLabel?: string;
};
const ModalExport: FunctionComponent<ModalExportProps> = ({
  open,
  onClose,
  onConfirm,
  resourceLabel,
}) => {
  const t = useTranslate();
  const [choice, setChoice] = useState<ExportChoice>('filtered');
  const { resource: resourceName } = useListContext();

  const label =
    (resourceLabel && resourceLabel.toLowerCase()) ??
    resourceName.toLowerCase();

  const options: { value: ExportChoice; label: string }[] = [
    {
      value: 'filtered',
      label: `${t('resource.modal.export')} ${label} ${t(
        'resource.modal.export.filtred'
      )}`,
    },
    {
      value: 'all',
      label: `${t('resource.modal.export.all')} ${label}`,
    },
  ];

  const handleConfirm = () => onConfirm(choice);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        {t('resource.modal.export.title')} {label}
      </DialogTitle>
      <DialogContent>
        <RadioGroup
          value={choice}
          onChange={(e) => setChoice(e.target.value as ExportChoice)}
        >
          {options.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio color="primary" />}
              label={option.label}
            />
          ))}
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="default">
          {t('ra.action.cancel')}
        </Button>
        <Button onClick={handleConfirm} color="primary" autoFocus>
          {t('ra.action.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalExport;
